module.exports = __webpack_public_path__ + "img/content-copy-outline-rounded.066f1446.svg";